import { render, staticRenderFns } from "./Rule-Category-Card.vue?vue&type=template&id=4518f225&lang=pug"
import script from "./Rule-Category-Card.vue?vue&type=script&lang=ts"
export * from "./Rule-Category-Card.vue?vue&type=script&lang=ts"
import style0 from "./Rule-Category-Card.vue?vue&type=style&index=0&id=4518f225&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports